import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { DEVICE_CODE_REGEX, FORMATTED_CODE_POSSIBLE_LENGTH, registrationCodeFormatter, } from "@jti/fe-common";
import { Controller, useFormContext } from "../../../../components/Form";
import { TextInput } from "../../../../components/Inputs";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./RegisterDeviceInput.module.scss";
export const RegisterDeviceInput = ({ fieldName = "registrationCode", requiredCodeLength, isInputDisabled = false, isDeviceRegistrationError, deviceRegistrationErrorText, onCleanErrors = () => { }, isInputHelperInfoTextVisible = true, }) => {
    const { __ } = useTranslations();
    const { control } = useFormContext();
    const { minCodeLength, maxCodeLength } = useMemo(() => {
        const minCodeLength = FORMATTED_CODE_POSSIBLE_LENGTH[Math.min(...requiredCodeLength)];
        const maxCodeLength = FORMATTED_CODE_POSSIBLE_LENGTH[Math.max(...requiredCodeLength)];
        return {
            minCodeLength,
            maxCodeLength,
        };
    }, [requiredCodeLength]);
    const formatDeviceCode = (deviceCode) => registrationCodeFormatter(deviceCode, " ", requiredCodeLength);
    return (_jsx(Controller, { name: fieldName, control: control, render: ({ field, fieldState: { error } }) => (_jsx(TextInput, { ...field, onChange: (e) => {
                field.onChange(e);
                onCleanErrors();
            }, disabled: isInputDisabled, isHelperTextVisible: true, formatter: formatDeviceCode, containerClassName: styles.input, "data-testid": "registrationCodeTextInput", isError: isDeviceRegistrationError || !!error, errorText: deviceRegistrationErrorText || error?.message, label: __("profile.devices.register_new.registration_code"), helperText: isInputHelperInfoTextVisible &&
                (__("profile.devices.register_new.dialog.registration_code_validation.format") ||
                    __("profile.devices.register_new.registration_code_placeholder")), placeholder: __("profile.devices.register_new.dialog.registration_code_placeholder") ||
                __("profile.devices.register_new.registration_code_placeholder") })), rules: {
            required: __("profile.devices.register_new.registration_code_validation.required"),
            pattern: {
                value: DEVICE_CODE_REGEX,
                message: __("profile.devices.register_new.registration_code_validation.format_error"),
            },
            maxLength: {
                value: maxCodeLength,
                message: __("profile.devices.register_new.registration_code_validation.format_error"),
            },
            minLength: {
                value: minCodeLength,
                message: __("profile.devices.register_new.registration_code_validation.format_error"),
            },
        } }));
};
//# sourceMappingURL=RegisterDeviceInput.js.map